// take a cameraPosition (an Array<Number*3>)
// and a cameraLookAt position (also an Array<Number*3>)
//
// and return a scene, camera, renderer, and controls to work with

import {
	ColorManagement,
	LinearDisplayP3ColorSpace,
	Scene,
	PerspectiveCamera,
	WebGLRenderer,
	DisplayP3ColorSpace,
	Vector3
} from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';

export default function initalizeThreeScene( cameraPosition, cameraLookAt ) {

	ColorManagement.enabled = true;
	ColorManagement.workingColorSpace = LinearDisplayP3ColorSpace;

	const scene = new Scene();
	const camera = new PerspectiveCamera(40, 1 / 1, .00025, 100);
	camera.position.set(...cameraPosition);
	camera.lookAt(...cameraLookAt);
	const renderer = new WebGLRenderer( {
		alpha: true,
		antialias: true
	} );

	renderer.outputColorSpace = DisplayP3ColorSpace;

	renderer.domElement.classList.add('color-solid');

	// todo make this dynamic?
	renderer.setSize(1000, 1000, false);

	const controls = new OrbitControls( camera, renderer.domElement );
	controls.enableZoom = false;
	controls.target =  new Vector3( ...cameraLookAt );

	return { scene, camera, renderer, controls }

}